import React from 'react';
import { AppSidebar } from '@/components/app-sidebar';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { SuspenseLoader } from './SuspenseLoader';
import { ManagerHeader } from './ManagerHeader';
import {
  BreadcrumbsProvider,
  BreadcrumbType,
} from '@/components/ConnectedBreadcrumbs';

const MainLayout: React.FC<{
  noSidebar?: boolean;
  breadCrumbs?: BreadcrumbType[];
  children?: React.ReactNode;
}> = (props) => {
  return (
    <SidebarProvider>
      {!props.noSidebar && <AppSidebar />}
      <SidebarInset className="min-w-0">
        <BreadcrumbsProvider>
          <ManagerHeader
            noSidebar={props.noSidebar}
            breadCrumbs={props.breadCrumbs}
          />
          <div className="flex flex-1">
            <React.Suspense fallback={<SuspenseLoader />}>
              {props.children}
            </React.Suspense>
          </div>
        </BreadcrumbsProvider>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default MainLayout;
